<template>
  <v-container fluid>
    <v-card>
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Clientes</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn
          depressed
          fab
          small
          color="primary lighten-5"
          class="mr-2"
          @click="$refs.dialogoImpressaoListagem.abrir()"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          depressed
          fab
          small
          color="primary lighten-5"
          class="mr-2"
          @click="tooglePesquisa"
        >
          <v-icon>search</v-icon>
        </v-btn>
        <!-- <v-btn
          depressed
          color="primary lighten-4"
          @click="$router.push('/clientes/adicionar')"
          v-if="user.tipo == 'representante' || user.tipo == 'fornecedor'"
          class="hidden-xs-only"
          >Adicionar</v-btn
        > -->
        <v-btn
          depressed
          color="primary lighten-4"
          @click="$router.push('/clientes/adicionar')"
          v-if="user.tipo == 'representante'"
          class="hidden-xs-only"
          >Adicionar</v-btn
        >
        <v-btn
          depressed
          color="primary lighten-4"
          @click="$router.push('/clientes/adicionar')"
          v-if="user.tipo == 'representante'"
          class="hidden-sm-and-up"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-app-bar>

      <v-expand-transition>
        <v-row dense v-show="exibirPesquisa" class="pa-2">
          <v-col cols="12" pa-2>
            <v-text-field
              ref="pesquisa"
              label="Pesquisa"
              v-model="pesquisa"
              prepend-inner-icon="search"
              solo
              background-color="grey lighten-2"
              clearable
              single-line
              hide-details
              placeholder="Pesquisa"
              color="primary"
              @click:clear="tooglePesquisa"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-expand-transition>

      <v-divider />

      <v-data-table
        :search="pesquisa"
        :headers="headers"
        :items="clientes"
        :loading="loading"
        :items-per-page="30"
        loading-text="Carregando dados..."
        :footer-props="{
          itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
          itemsPerPageText: 'Registros Exibidos',
        }"
      >
        <!-- <template v-slot:item.numero="{ item }">
          {{ item.numero }}<br />
          <span class="caption font-weight-light">{{ item.cnpj }}</span>
        </template> -->
        <template v-slot:item.razao_social="{ item }">
          {{ item.razao_social }}<br />
          <span class="caption font-weight-light">{{ item.cnpj }}</span>
        </template>
        <template v-slot:item.lojas="{ item }">
          {{ item.lojas.length }}
        </template>
        <template v-slot:item.opcoes="{ item }">
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                v-if="
                  user.tipo == 'master' ||
                    user.tipo == 'representante' ||
                    user.tipo == 'fornecedor'
                "
                @click="$router.push('clientes/' + item.id + '/editar')"
              >
                <v-list-item-title>
                  <v-icon class="mr-4">mdi-pencil</v-icon>Editar
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="abrirDialogoDetalhes(item)">
                <v-list-item-title>
                  <v-icon class="mr-4">list_alt</v-icon>Detalhes
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="abrirDialogoImpressaoFicha(item)">
                <v-list-item-title>
                  <v-icon class="mr-4">print</v-icon>Imprimir
                </v-list-item-title>
              </v-list-item>

              <v-list-item
                @click="abrirDialogoExcluir(item)"
                v-if="user.tipo == 'fornecedor'"
              >
                <v-list-item-title>
                  <v-icon class="mr-4">close</v-icon>Excluir
                </v-list-item-title>
              </v-list-item>
            </v-list>

            <!-- <v-list v-if="user.tipo == 'representante'">
              <v-list-item
                @click="$router.push('clientes/' + item.id + '/editar')"
              >
                <v-list-item-title>
                  <v-icon>edit</v-icon>Editar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="abrirDialogoExcluir(item)">
                <v-list-item-title>
                  <v-icon>close</v-icon>Excluir
                </v-list-item-title>
              </v-list-item> 
              <v-list-item @click="abrirDialogoAtivacao(item)" v-if="item.ativo == 1">
                <v-list-item-title>
                  <v-icon>block</v-icon>Desativar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="abrirDialogoAtivacao(item)" v-else>
                <v-list-item-title>
                  <v-icon>done</v-icon>Ativar
                </v-list-item-title>
              </v-list-item>
            </v-list> -->
          </v-menu>
        </template>
      </v-data-table>
    </v-card>

    <as-dialogo
      ref="dialogoExcluir"
      title="Excluir Cliente"
      max-width="440px"
      hideCloseButton
    >
      <p>Deseja excluir este cliente?</p>
      <div slot="botoes">
        <v-btn color="white" @click="$refs.dialogoExcluir.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          color="error"
          @click="excluir"
          :disabled="excluindo"
          :loading="excluindo"
          >Excluir</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoDetalhes"
      title="Cliente Detalhes"
      max-width="960px"
    >
      <v-row dense>
        <v-col cols="12" sm="8">
          <v-text-field
            label="Nome"
            ref="nome"
            v-model="cliente.nome"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            label="Email"
            ref="email"
            v-model="cliente.endereco.email"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Rua"
            ref="rua"
            v-model="cliente.endereco.rua"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <v-text-field
            label="Número"
            ref="numero"
            v-model="cliente.endereco.numero"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            label="Complemento"
            ref="complemento"
            v-model="cliente.endereco.complemento"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="4">
          <v-text-field
            label="Bairro"
            ref="bairro"
            v-model="cliente.endereco.bairro"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <v-text-field
            label="CEP"
            ref="cep"
            v-model="cliente.endereco.cep"
            mask="##.###-###"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Estado"
            ref="estado"
            v-model="cliente.endereco.estado"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Cidade"
            ref="cidade"
            v-model="cliente.endereco.cidade"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
            label="Telefone"
            ref="telefone"
            v-model="cliente.endereco.telefone"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
            label="Celular"
            ref="celular"
            v-model="cliente.endereco.celular"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="4">
          <v-text-field
            label="Responsável"
            ref="responsavel_nome"
            v-model="cliente.responsavel_nome"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <v-text-field
            label="CPF do Responsável"
            ref="responsavel_cpf"
            v-model="cliente.responsavel_cpf"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Representante"
            ref="representante"
            v-model="cliente.representante_nome"
            readonly
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>

      <v-card class="mt-4">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Lojas</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-app-bar>

        <v-data-table
          :headers="lojasHeaders"
          :items="cliente.lojas || []"
          hide-default-footer
          height="200px"
        >
          <template v-slot:item.opcoes="{ item }">
            <v-btn icon @click="abrirLojaDetalhes(item)">
              <v-icon>mdi-information</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </as-dialogo>

    <as-dialogo ref="dialogoLojaDetalhes" title="Detalhes" max-width="960px">
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Razão Social"
            v-model="loja.razao_social"
            readOnly
            hideDetails
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Nome Fantasia"
            v-model="loja.nome_fantasia"
            readOnly
            hideDetails
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-text-field
            label="CNPJ"
            v-model="loja.cnpj"
            readOnly
            hideDetails
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Inscrição Estadual"
            v-model="loja.ie"
            readOnly
            hideDetails
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="4">
          <v-text-field
            label="Rua"
            v-model="loja.endereco.rua"
            readOnly
            hideDetails
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
            label="Complemento"
            v-model="loja.endereco.complemento"
            readOnly
            hideDetails
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <v-text-field
            label="Número"
            v-model="loja.endereco.numero"
            readOnly
            hideDetails
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
            label="Bairro"
            v-model="loja.endereco.bairro"
            readOnly
            hideDetails
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="loja.endereco.estado"
            label="Estado"
            readOnly
            hideDetails
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="loja.endereco.cidade"
            label="Cidade"
            readOnly
            hideDetails
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="2">
          <v-text-field
            label="CEP"
            v-model="loja.endereco.cep"
            readOnly
            hideDetails
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
            label="Telefone"
            v-model="loja.endereco.telefone"
            readOnly
            hideDetails
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
            label="Celular"
            v-model="loja.endereco.celular"
            readOnly
            hideDetails
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            label="Email"
            v-model="loja.endereco.email"
            readOnly
            hideDetails
          ></v-text-field>
        </v-col>
      </v-row>
    </as-dialogo>

    <as-dialogo
      ref="dialogoImpressaoListagem"
      title="Imprimir"
      max-width="440px"
      hideCloseButton
    >
      <v-label>Deseja imprimir a listagem de clientes?</v-label>
      <div class="pt-8" style="display: flex; justify-content: flex-end;">
        <v-btn
          depressed
          class="mr-4"
          @click="$refs.dialogoImpressaoListagem.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="imprimirListagem"
          :disabled="imprimindo"
          :loading="imprimindo"
          >Imprimir</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoImpressaoFicha"
      title="Imprimir"
      max-width="440px"
      hideCloseButton
      hideDivider
    >
      <v-label>Deseja imprimir a os dados do cliente?</v-label>
      <div slot="botoes">
        <v-btn
          class="mr-4"
          depressed
          @click="$refs.dialogoImpressaoFicha.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="imprimirFichaDoCliente"
          :disabled="imprimindo"
          :loading="imprimindo"
          >Imprimir</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoAtivacao"
      :title="cliente.ativo ? 'Desativar Cliente' : 'Ativar Cliente'"
      max-width="440px"
      hideCloseButton
    >
      <p>
        Deseja confirmar a
        <span v-if="cliente.ativo == 0">ativação</span>
        <span v-else>desativação</span> deste cliente?
      </p>
      <div slot="botoes">
        <v-btn color="white" @click="$refs.dialogoAtivacao.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          color="primary"
          @click="ativarDesativar"
          :disabled="ativando"
          :loading="ativando"
          v-if="cliente.ativo == 0"
          >Ativar</v-btn
        >
        <v-btn
          color="primary"
          @click="ativarDesativar"
          :disabled="ativando"
          :loading="ativando"
          v-else
          >Desativar</v-btn
        >
      </div>
    </as-dialogo>

    <!-- <as-dialogo ref="dialogo" title="Desvincular Cliente" max-width="728px">
      <p>Tem certeza que desvincular este cliente?</p>
      <div slot="botoes">
        <v-btn color="white" @click="$refs.dialogo.fechar()" :disabled="loadingDesvincular">Cancelar</v-btn>
        <v-btn color="primary" @click="desvincular" :loading="loadingDesvincular">Desvincular</v-btn>
      </div>
    </as-dialogo>-->
  </v-container>
</template>

<script>
import ServiceClientes from "@/services/clientes.js";
import ServiceImpressoes from "@/services/impressoes.js";
import config from "@/config";

export default {
  name: "clientes",
  data() {
    return {
      user: {},
      rodada: {},
      loading: false,
      loadingDesvincular: false,
      clientes: [],
      cliente: { endereco: {} },
      headers: [],
      lojasHeaders: [
        { text: "Razão Social", value: "razao_social", width: "40%" },
        { text: "Nome Fantasia", value: "nome_fantasia", width: "30%" },
        { text: "CNPJ", value: "cnpj", width: "25%" },
        {
          text: "",
          value: "opcoes",
          sortable: false,
          width: "5%",
          align: "end",
        },
      ],
      loja: { endereco: {} },
      pesquisa: "",
      exibirPesquisa: false,
      excluindo: false,
      imprimindo: false,
      ativando: false,
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.rodada = JSON.parse(localStorage.getItem("rodada"));
    this.listar();
    if (this.user.tipo == "administrador" || this.user.tipo == "master") {
      this.headers = [
        { text: "Empresa", value: "nome", width: "35%" },
        { text: "Responsável", value: "responsavel_nome", width: "30%" },
        { text: "Representante", value: "representante_nome", width: "25%" },
        {
          text: "Lojas",
          value: "lojas",
          width: "5%",
          sortable: false,
          align: "center",
        },
        {
          text: "",
          value: "opcoes",
          sortable: false,
          width: "5%",
          align: "end",
        },
        {
          text: "CNPJ",
          value: "cnpjs",
          align: " d-none",
        },
      ];
      this.cliente = {
        razao_social: "",
        nome_fantasia: "",
        cnpj: "",
        ie: "",
        endereco: {
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
      };
    } else if (this.user.tipo == "representante") {
      this.headers = [
        { text: "Empresa", value: "nome", width: "45%" },
        { text: "Responsável", value: "responsavel_nome", width: "45%" },
        {
          text: "Lojas",
          value: "lojas",
          width: "5%",
          sortable: false,
          align: "center",
        },
        {
          text: "",
          value: "opcoes",
          sortable: false,
          width: "5%",
          align: "end",
        },
        {
          text: "CNPJ",
          value: "cnpjs",
          align: " d-none",
        },
      ];
      this.cliente = {
        razao_social: "",
        nome_fantasia: "",
        cnpj: "",
        ie: "",
        endereco: {
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
      };
    } else if (this.user.tipo == "fornecedor") {
      if (this.rodada != null && Object.keys(this.rodada).length > 0) {
        this.headers = [
          { text: "Nome Fantasia", value: "nome_fantasia", width: "30%" },
          {
            text: "Razão Social",
            value: "razao_social",
            width: "30%",
            class: "hidden-xs-only",
          },
          { text: "Responsável", value: "responsavel_nome", width: "20%" },
          { text: "Representante", value: "representante_nome", width: "15%" },
          {
            text: "CNPJ",
            value: "cnpj",
            align: " d-none",
          },
        ];
      } else {
        this.headers = [
          { text: "Número", value: "numero", width: "10%", align: "center" },
          { text: "Empresa", value: "nome", width: "40%" },
          { text: "Responsável", value: "responsavel_nome", width: "40%" },
          {
            text: "Lojas",
            value: "lojas",
            width: "5%",
            sortable: false,
            align: "center",
          },
          {
            text: "",
            value: "opcoes",
            sortable: false,
            width: "5%",
            align: "end",
          },
          {
            text: "CNPJ",
            value: "cnpjs",
            align: " d-none",
          },
        ];
      }
      this.cliente = {
        razao_social: "",
        nome_fantasia: "",
        cnpj: "",
        ie: "",
        endereco: {
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
      };
    }
  },

  methods: {
    async listar() {
      try {
        this.loading = true;
        let response = "";
        if (this.user.tipo == "representante") {
          response = await ServiceClientes.carregarClientesRepresentante(
            this.user.representante_id
          );
        } else if (this.user.tipo == "administrador") {
          response = await ServiceClientes.carregarClientesAdministrador(
            this.user.administrador_id
          );
        } else if (this.user.tipo == "fornecedor") {
          if (this.rodada != null && Object.keys(this.rodada).length > 0) {
            response = await ServiceClientes.carregarClientesFornecedor(
              this.user.fornecedor_id,
              this.rodada.id
            );
          } else {
            response = await ServiceClientes.carregarClientesPropriosFornecedor(
              this.user.fornecedor_id
            );
          }
        } else if (this.user.tipo == "master") {
          response = await ServiceClientes.carregarClientesMaster();
        }
        if (this.user.tipo == "fornecedor") {
          this.clientes = response.data.clientes;
        } else {
          this.clientes = response.data.clientes.map((cli) => ({
            ...cli,
            cnpjs: cli.lojas.map((loj) => loj.cnpj).join(","),
          }));
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    abrirDialogoExcluir(cliente) {
      this.cliente = this.clone(cliente);
      this.$refs.dialogoExcluir.abrir();
    },
    async excluir() {
      try {
        this.excluindo = true;
        let response = await ServiceClientes.excluir(this.cliente.id);

        if (response.data.status == 1) {
          this.$eventbus.notificar(response.data.msg);
          this.listar();
        } else if (response.data.status == 2) {
          this.$eventbus.erro(response.data.msg);
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao excluir cliente");
      } finally {
        this.excluindo = false;
        this.$refs.dialogoExcluir.fechar();
      }
    },
    abrirDialogoDetalhes(cliente) {
      this.cliente = {
        ...cliente,
        ...(cliente.endereco
          ? { endereco: cliente.endereco }
          : { endereco: {} }),
      };
      this.$refs.dialogoDetalhes.abrir();
    },
    async imprimirListagem() {
      try {
        this.imprimindo = true;
        let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
          ? "remota"
          : "local";
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceImpressoes.listarClientes({
          impressao,
          rodada_id: this.$store.state.rodada.id,
        });
        if (impressao == "local") {
          this.$store.commit("setPdfUrl", pdf);
        } else {
          this.$eventbus.notificar(
            "Impressão encaminhada para a Ilha de Impressão com sucesso"
          );
        }
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir listagem de clientes");
      } finally {
        this.imprimindo = false;
        this.$refs.dialogoImpressaoListagem.fechar();
      }
    },
    abrirDialogoImpressaoFicha(cliente) {
      this.cliente = {
        ...cliente,
        ...(cliente.endereco
          ? { endereco: cliente.endereco }
          : { endereco: {} }),
      };
      this.$refs.dialogoImpressaoFicha.abrir();
    },
    async imprimirFichaDoCliente() {
      try {
        this.imprimindo = true;
        let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
          ? "remota"
          : "local";
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceImpressoes.fichaDoCliente({
          impressao,
          cliente_id: this.cliente.id,
          rodada_id: this.$store.state.rodada.id,
        });
        this.$refs.dialogoImpressaoFicha.fechar();
        if (impressao == "local") {
          this.$store.commit("setPdfUrl", pdf);
        } else {
          this.$eventbus.notificar(
            "Impressão encaminhada para a Ilha de Impressão com sucesso"
          );
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao imprimir!");
      } finally {
        this.imprimindo = false;
      }
    },
    abrirDialogoAtivacao(cliente) {
      this.cliente = this.clone(cliente);
      this.$refs.dialogoAtivacao.abrir();
    },
    abrirLojaDetalhes(loja) {
      this.loja = this.clone(loja);
      this.$refs.dialogoLojaDetalhes.abrir();
    },
    async ativarDesativar() {
      try {
        this.ativando = true;
        let response = await ServiceClientes.ativarDesativar(this.cliente.id);

        this.listar();
        if (this.cliente.ativo) {
          this.$eventbus.notificar("Cliente desativado com sucesso");
        } else {
          this.$eventbus.notificar("Cliente ativado com sucesso");
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao ativar/desativar cliente");
      } finally {
        this.ativando = false;
        this.$refs.dialogoAtivacao.fechar();
      }
    },

    /* dialogoDesvincular(cliente) {
            this.cliente = cliente;
            this.$refs.dialogo.abrir();
          },

          async desvincular() {
            try {
              this.loadingDesvincular = true;
              await ServiceClientes.desvincular(this.user.representante_id, this.cliente.id)
              await this.listar();
              this.$refs.dialogo.fechar();
            } catch(error) {
              console.log(error);
            } finally {
              this.loadingDesvincular = false;
            }
          }, */

    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
  },
};
</script>

<style></style>
